import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../hooks/useAuthStore';
import { therapistNeedsOnboarding, useTherapistSetup } from '../../hooks/useTherapistSetup';
import { WorkspaceShell, type WorkspaceNavItem } from './WorkspaceShell';

const THERAPIST_NAV: WorkspaceNavItem[] = [
  { to: '/therapist/dashboard', label: 'Dashboard', icon: '📊', end: true },
  { to: '/therapist/availability', label: 'Availability', icon: '📅' },
  { to: '/therapist/earnings', label: 'Earnings', icon: '💰' },
  { to: '/therapist/profile', label: 'Public profile', icon: '✏️' },
  { to: '/therapist/settings', label: 'Settings', icon: '⚙️' },
];

const ONBOARDING_NAV: WorkspaceNavItem = {
  to: '/therapist/onboarding',
  label: 'Onboarding',
  icon: '📋',
};

export function TherapistWorkspaceLayout() {
  const { user } = useAuthStore();
  const { data: setup } = useTherapistSetup();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'therapist') return <Navigate to="/" replace />;

  const nav = therapistNeedsOnboarding(setup) ? [...THERAPIST_NAV, ONBOARDING_NAV] : THERAPIST_NAV;

  return (
    <WorkspaceShell
      title="Practice workspace"
      subtitle="Manage sessions, schedule, and payouts"
      nav={nav}
    />
  );
}
